import { ArrowBackIosNew } from '@mui/icons-material';

import { McpClientIcon } from 'components/shared/bumperMcp/McpClientIcon';

import { MCP_CLIENTS } from '../constants';

import {
  BackButton,
  ClientPicker,
  ClientPickerLabel,
  ClientTab,
} from './styledComponents';
import { ClaudeTab } from './tabs/ClaudeTab';

interface ConnectSectionProps {
  onBackClick: () => void;
}

const CLAUDE_TAB_ID = 'mcp-tab-claude';
const CLAUDE_PANEL_ID = 'mcp-panel-claude';

export const ConnectSection = ({ onBackClick }: ConnectSectionProps) => (
  <div>
    <BackButton
      type="button"
      onClick={onBackClick}
      data-testid="mcp-back-button"
    >
      <ArrowBackIosNew sx={{ fontSize: 14 }} aria-hidden />
      Back
    </BackButton>
    <ClientPickerLabel id="mcp-client-label">
      Choose your MCP client
    </ClientPickerLabel>
    <ClientPicker role="tablist" aria-labelledby="mcp-client-label">
      {MCP_CLIENTS.map(({ id, label, available }) => (
        <ClientTab
          key={id}
          type="button"
          role="tab"
          id={`mcp-tab-${id}`}
          aria-selected={available}
          aria-controls={available ? CLAUDE_PANEL_ID : undefined}
          selected={available}
          disabled={!available}
        >
          <McpClientIcon client={id} size={id === 'claude' ? 24 : 20} />
          {label}
        </ClientTab>
      ))}
    </ClientPicker>
    <div role="tabpanel" id={CLAUDE_PANEL_ID} aria-labelledby={CLAUDE_TAB_ID}>
      <ClaudeTab />
    </div>
  </div>
);
